import CreatorEditProfilePage from "./CreatorEditProfilePage";

export default CreatorEditProfilePage;
